import React from 'react';
import gql from 'graphql-tag';
import { API, graphqlOperation } from 'aws-amplify';
import { GetGiidePaddleTransactionsQuery } from '../../graphql/api';
import { useDispatch, useSelector } from 'react-redux';
import { setPaddleTransactions } from '../../actions';
import { IState, PaddleTransactions } from '../../graphql/types';

const getGiidePaddleTransactions = gql`
  query getGiidePaddleTransactions($subscriptionId: Int!) {
    getGiidePaddleTransactions(subscriptionId: $subscriptionId) {
      transactions {
        amount
        checkoutId
        createdAt
        currency
        email
        giideTenantID
        giideUserID
        isOneOff
        isSubscription
        marketingConsent
        orderId
        productId
        receiptUrl
        status
        subscriptionId
        subscriptionStatus
        userId
      }
      errorMessage
    }
  }
`;

const usePaddleTransactions = (
  subscriptionId?: number | null,
  noAutoFetch?: boolean
) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<boolean>(false);

  const data = useSelector<IState, PaddleTransactions | undefined>(
    state => state.paddleTransactions
  );

  const refetch = React.useCallback(() => {
    // console.log('inside transactions refetch, id: ', subscriptionId);
    setLoading(true);
    if (!subscriptionId) {
      setLoading(false);
      return;
    }

    (
      API.graphql(
        graphqlOperation(getGiidePaddleTransactions, { subscriptionId })
      ) as Promise<{
        data: GetGiidePaddleTransactionsQuery;
      }>
    )
      .then(result => {
        // console.log('transactions result: ', result.data);
        dispatch(setPaddleTransactions(result.data.getGiidePaddleTransactions));
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setError(true);
      });
  }, [subscriptionId, dispatch]);

  React.useEffect(() => {
    if (!data && !noAutoFetch) refetch();
  }, [data, refetch, noAutoFetch]);

  return { data, refetch, loading, error };
};

export default usePaddleTransactions;
